import {
    FETCH_STATS_SUCCESS,
    FETCH_STATS_ERROR,
    UPDATE_CONNECTED_USERS,
    FETCH_USER_STATS,
    FETCH_SUBSCRIPTION_STATS,
    FETCH_REVENUE_STATS,
    FETCH_PRODUCT_STATS,
    FETCH_ACTIVE_USER_STATS,
    FETCH_CONNECTED_USERS_COUNT
} from '../actions/stats';

const initialState = {
    totalUsers: 0,
    totalSubscribers: 0,
    connectedUsers: 0,
    totalActiveUsers: 0,
    activeThresholdDays: 30,
    totalRevenue: 0,
    monthlyStats: {
        users: Array(12).fill(0),
        revenue: Array(12).fill(0),
        activeUsers: Array(12).fill(0)
    },
    totalProducts: 0,
    totalSubstances: 0,
    totalEquivalences: 0,
    totalInteractions: 0,
    totalPosologies: 0,
    totalLaboratories: 0,
    subscriptionStats: {
        annual: { count: 0, revenue: 0 },
        quarterly: { count: 0, revenue: 0 },
        premium: { count: 0, revenue: 0 }
    },
    error: null
};

export default function statsReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_STATS_SUCCESS:
            return {
                ...state,
                ...action.payload,
                error: null
            };
        
        case FETCH_USER_STATS:
            return {
                ...state,
                totalUsers: action.payload.totalUsers,
                monthlyStats: {
                    ...state.monthlyStats,
                    ...action.payload.monthlyStats
                },
                error: null
            };

        case FETCH_SUBSCRIPTION_STATS:
            return {
                ...state,
                totalSubscribers: action.payload.totalSubscribers,
                totalRevenue: action.payload.totalRevenue,
                subscriptionStats: action.payload.subscriptionStats || state.subscriptionStats,
                monthlyStats: {
                    ...state.monthlyStats,
                    ...action.payload.monthlyStats
                },
                error: null
            };

        case FETCH_REVENUE_STATS:
            return {
                ...state,
                totalRevenue: action.payload.totalRevenue,
                error: null
            };

        case FETCH_PRODUCT_STATS:
            return {
                ...state,
                ...action.payload,
                error: null
            };
        
        case FETCH_ACTIVE_USER_STATS:
            return {
                ...state,
                totalActiveUsers: action.payload.totalActiveUsers,
                activeThresholdDays: action.payload.activeThresholdDays,
                monthlyStats: {
                    ...state.monthlyStats,
                    ...action.payload.monthlyStats
                },
                error: null
            };
        
        case UPDATE_CONNECTED_USERS:
            return {
                ...state,
                connectedUsers: action.payload,
                error: null
            };

        case FETCH_CONNECTED_USERS_COUNT:
            return {
                ...state,
                connectedUsers: action.payload.connectedUsers,
                error: null
            };

        case FETCH_STATS_ERROR:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
}
